const ossConfig = {
  uploadHost: "http://pinzhenimg.oss-cn-shenzhen.aliyuncs.com",
  type: "scs",
  ossParams: {
    region: "oss-cn-shenzhen",
    success_action_status: "200", // 默认200
    accessKeyId: "LTAI5tC1M8weTQqWWP4tk5oF",
    accessKeySecret: "M9M7IHqJzL1zk420AA3XlEZDAEDO3I",
    bucket: "pinzhenimg",
    // 支持https，即如果网站本身是http的，上传图片返回的地址也是https
    secure: true,
  },
};
let env =
  process.env.NODE_ENV === "development"
    ? "development"
    : process.env.VUE_APP_TITLE === "alpha"
    ? "alpha"
    : "production";

switch (env) {
  case "development":
    // 测试站点
    break;
  case "production":
    // 格雷站点
    break;
  case "alpha":
    // 夏娃站点
    break;
}

export default ossConfig;
